// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3KtcA","header":"ClearentDisclaimer_header__3Lo7b","inner":"ClearentDisclaimer_inner__quuak"};